import { Component, Input, OnInit } from '@angular/core';

import { env } from '../../../environments/environment';
import { defs } from '../../defs';
import { NarwhalDto } from '../../api/narwhalDto';
import { BodyPart } from '../../api/bodyPart';

@Component({
	selector: 'narwhalia-narwhal-image-gen',
	templateUrl: './narwhal-image-gen.component.html',
	styleUrls: ['./narwhal-image-gen.component.scss']
})
export class NarwhalImageGenComponent implements OnInit {
	@Input() narwhal: NarwhalDto;
	bodyParts: BodyPart[];
	bodyPartKeys = ['tail', 'pattern-tail', 'body', 'pattern-body', 'belly', 'head', 'eye', 'lip', 'mustache', 'hair', 'horn'];
	assetBaseURL = env.assetBaseURL;

	constructor() {
		this.bodyParts = [];
	}

	ngOnInit() {
		if (this.narwhal.looks) {
			this.bodyParts = this.bodyPartKeys.filter(this.filterOptional).map(bodyPartKey => ({
				path: `male/${this.getPath(bodyPartKey)}.svg`,
				filter: this.getFilter(bodyPartKey)
			}));
		} else {
			let path;
			switch (this.narwhal.gender) {
				case 'male':
					path = `alpha/${this.narwhal.picture}`;
					break;
				case 'female':
					path = `female/${this.narwhal.picture}`;
					break;
			}
			this.bodyParts.push({ path });
		}
	}

	filterOptional = bodyPartyKey => {
		const [bodyPartKeySplitted] = bodyPartyKey.split('-');
		if (bodyPartKeySplitted !== 'belly' && !this.narwhal.looks[bodyPartKeySplitted]) {
			return false;
		}
		return true;
	};

	getPath(bodyPartKey) {
		const { looks } = this.narwhal;
		switch (bodyPartKey) {
			case 'belly':
				return `${bodyPartKey}/${looks.body}`;
			case 'pattern-body':
			case 'pattern-tail':
				const [mainPath, subPath] = bodyPartKey.split('-');
				return `${mainPath}/${subPath}/${looks[subPath]}/${looks[mainPath]}`;
			case 'hair':
				return `${bodyPartKey}/${looks[bodyPartKey]}-${looks.head}`;
			default:
				return `${bodyPartKey}/${looks[bodyPartKey]}`;
		}
	}

	getFilter(bodyPartKey) {
		const { colors } = this.narwhal;
		switch (bodyPartKey) {
			case 'body':
			case 'head':
			case 'tail':
				return defs.colorPalette.skin[colors.skin - 1];
			case 'pattern-body':
			case 'pattern-tail':
				const [mainPath] = bodyPartKey.split('-');
				return defs.colorPalette[mainPath][colors[mainPath] - 1];
			case 'hair':
			case 'belly':
			case 'eye':
				return defs.colorPalette[bodyPartKey][colors[bodyPartKey] - 1];
		}
	}
}